module.exports = __webpack_public_path__ + "components/flag/static/square/pg-9812a119d8a828d87faccaa03b69cbd5.svg";